import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { useProductContext } from '@bluheadless/ui-logic/src/providers/product'
import { useNotification } from '@bluheadless/ui-logic/src/hooks/useNotification'
import { object } from 'prop-types'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import InstallmentsPriceProduct from '../installments-price'
import Rating from './rating'
import {
	ActionWishList,
	CollectionLabel,
	Name,
	ProductPrice,
	Sku,
	Title,
	TitleWrapper,
	VatLabel,
} from './sidebar-top.styled'
import OmnibusPrice from '../../../molecules/omnibus-price/omnibus-price'

const SidebarTop = ({ reviewsRef = null, titleProps }) => {
	const productContextValue = useProductContext()
	const { enqueueNotification } = useNotification()
	const { formatMessage } = useIntl()

	const {
		catalog: {
			products: {
				attributesMapping: { collection },
			},
			vatLabel,
		},
	} = useConfig()

	const [
		{
			prices: { hide },
			product: {
				attributes,
				name,
				rating: { summary, count },
			},
			errorWishList,
			isInWishList,
			loadingWishList,
		},
		{ addToWishList, removeFromWishList },
	] = productContextValue

	const addToWishlistHandler = useCallback(async () => {
		try {
			await addToWishList()
		} catch (error) {
			enqueueNotification({
				uiProps: {
					message: errorWishList?.message || formatMessage({ id: 'add_to_wishlist_error' }),
					severity: 'error',
				},
			})
		}
	}, [enqueueNotification, addToWishList, errorWishList, formatMessage])

	const removeFromWishListHandler = useCallback(async () => {
		try {
			await removeFromWishList()
		} catch (error) {
			enqueueNotification({
				uiProps: {
					message: errorWishList?.message || formatMessage({ id: 'remove_from_wishlist_error' }),
					severity: 'error',
				},
			})
		}
	}, [enqueueNotification, removeFromWishList, errorWishList, formatMessage])

	return (
		<>
			<TitleWrapper hasCollection={attributes[collection]?.value ? true : false}>
				{attributes[collection]?.value && (
					<CollectionLabel color="grey.main">{attributes[collection]?.value}</CollectionLabel>
				)}

				<Title component="div" hasCollection={attributes[collection]?.value ? true : false}>
					<Name component="h1" variant="h1" {...titleProps}>
						{name}
					</Name>
					<Sku color="grey.main">{attributes?.short_description?.value}</Sku>
				</Title>

				<ActionWishList
					added={isInWishList}
					disabled={loadingWishList}
					loading={loadingWishList}
					onClick={isInWishList ? removeFromWishListHandler : addToWishlistHandler}
					variant="icon"
				/>
			</TitleWrapper>

			<Rating count={count} summary={summary} readOnly reviewsRef={reviewsRef} />

			<ProductPrice />

			{!hide && vatLabel && <VatLabel variant="caption">{vatLabel}</VatLabel>}

			<OmnibusPrice />

			<InstallmentsPriceProduct />
		</>
	)
}

SidebarTop.propTypes = {
	reviewsRef: object,
	titleProps: object,
}

export default SidebarTop
